import { useProductNameList } from './useProductNameList';

import makeClasses from './ProductNameList.style';

import type { FullMenuCatalog } from 'features/menu-page/domain';

export function ProductNameList(props: Props) {
  const { customGroupId, catalog } = props;

  const {
    showRestNames,
    restNamesLength,
    names,
    restNames,
  } = useProductNameList({ customGroupId, catalog });

  const _classes = makeClasses();

  return (
    <span aria-label='product-name-list'>
      {names}
      {showRestNames && (
        <span aria-label='rest-names' className={_classes.restList}>
          <span aria-label='quantity'>{`, ...(+${restNamesLength})`}</span>
          <small>{restNames}</small>
        </span>
      )}
    </span>
  );
}

interface Props {
  customGroupId: number;
  catalog: FullMenuCatalog;
}
